export const SYSTEM_TYPE = "SYSTEM_TYPE";
